import { assignInlineVars } from '@vanilla-extract/dynamic';
import { vars } from './contract.css';
function createTheme(customVars) {
    if (!customVars)
        return {};
    return assignInlineVars(vars, customVars);
}
export default createTheme;
//# sourceMappingURL=create-theme.js.map